<!--  -->
<template>
  <div class="Sidebar">
    <div class="left">
      <el-menu
        :default-active="pathIndex + ''"
        background-color="#f0f2f4"
        text-color="#333333"
        active-text-color="#3967EE"
      >
        <div v-for="(item, index) in navList" :key="index">
          <el-menu-item
            :index="index + ''"
            v-if="!item.child.length"
            @click="navClick(item)"
            class="flex items-center"
          >
            <svg-icon
              v-if="item.icon"
              :icon-class="item.icon"
              class="mr-[7px]"
            ></svg-icon>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>

          <el-submenu :index="index + ''" v-else>
            <template slot="title">
              <div class="flex items-center">
                <svg-icon
                  v-if="item.icon"
                  :icon-class="item.icon"
                  class="mr-[7px]"
                ></svg-icon>
                <span>{{ item.title }}</span>
              </div>
            </template>
            <el-menu-item
              :index="`${index}-${k}`"
              v-for="(j, k) in item.child"
              :key="k"
              @click="navClick(j)"
              >{{ j.title }}</el-menu-item
            >
          </el-submenu>
        </div>
      </el-menu>
    </div>

    <div
      style="
        overflow: auto;
        width: calc(100% - 20px);
        height: calc(100vh - 68px);
      "
    >
      <div class="view">
        <slot></slot>
        <div class="h-[20px]"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["sidebarRouters", "sidebar"]),
  },
  data() {
    return {
      pathIndex: 0,
      navList: [],
    };
  },
  watch: {
    "$route.path"() {
      this.get_navActive();
    },
  },
  created() {
    this.get_navActive();
  },
  mounted() {
    // debugger
    let list = this.sidebarRouters.filter((x) => !x.hidden);
    let navList = [];
    list.forEach((item, index) => {
      navList.push({
        title: item?.title,
        icon: item?.icon,
        path: item.path,
        child: [],
      });
      const child = item.children && item.children.filter((x) => !x.hidden);
      // if (child.length===1) {
      //   if(child[0].path) navList[index].path = item.path + '/'+child[0].path
      // }
      child &&
        child.forEach((x) => {
          navList[index].child.push({
            title: x?.title,
            path: item.path + "/" + x.path,
          });
        });
    });

    this.navList = navList;
    this.get_navActive();
  },
  methods: {
    navClick(item) {
      if (item.path == "/statistics/bigScreen") {
        let routeUrl = this.$router.resolve({
          path: "/bigScreen",
        });
        return window.open(routeUrl.href, "_blank");
      }

      if (!item.path) return;
      this.$router.push({ path: item.path });
    },
    get_navActive() {
      // let index = this.navList.findIndex((v) => v.path == this.$route.path);
      let pathIndex = "";
      this.navList.forEach((item, index) => {
        if (item.child && item.child.length) {
          item.child.forEach((x, y) => {
            if (x.path === this.$route.path) pathIndex = `${index}-${y}`;
          });
        } else {
          if (item.path === this.$route.path) pathIndex = index;
        }
      });
      this.pathIndex = pathIndex;
    },
  },
};
</script>
<style scoped lang="scss">
.Sidebar {
  display: flex;
  padding: 20px;
  padding-top: 0;
  padding-right: 0;
  box-sizing: border-box;

  .left {
    min-width: 177px;
    height: calc(100vh - 88px);
    overflow: auto;
    overflow-x: hidden;
    margin-right: 34px;
    padding-top: 20px;
    ::v-deep {
      .el-menu {
        border: none;
      }
      .el-submenu .el-menu-item {
        min-width: 177px;
      }
      .is-active {
        background-color: rgba(17, 69, 213, 0.06) !important;
        border-radius: 6px;
      }
      .el-submenu__title:hover,
      .el-menu-item:hover {
        border-radius: 6px;
        background-color: rgba(79, 79, 79, 0.06) !important;
      }
    }
    .el-menu-item.is-active {
      font-weight: bold;
    }
  }
  .view {
    background: #f0f2f4;
    min-width: 1100px;
    width: 100%;
    padding-right: 20px;
    box-sizing: border-box;
    margin-top: 20px;
  }
}
</style>
